module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12QkcWL/tc-custom/9781416979487.jpg?1730537180730",
      "alt": "This image is the cover for the book Perfect Cover, Nancy Drew Girl Detective"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Perfect Cover, Nancy Drew Girl Detective\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("My friends and I are headed to the Big Apple! "), _c('br'), _c('br'), _vm._v(" George, Bess, and I continue our investigation of the Miss Pretty Face Beauty Pageant in New York City, where the next round of competition is being held. When I get there, Pretty Face Cosmetics seems creepier than ever! "), _c('br'), _c('br'), _vm._v(" Suspicious security men, animal rights protesters, and a mysterious scientist make this the craziest case I've ever investigated. And when someone suddenly goes missing, I realize it just might be the most dangerous!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolyn Keene\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carolyn Keene is the author of the ever-popular Nancy Drew books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0